import { createFileRoute } from "@tanstack/react-router"
import DesignSystemMessageScroller from "~/pages/design-system/components/MessageScroller"

export const Route = createFileRoute("/_auth/internal/design-system/components/message-scroller")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemMessageScroller />
}
